import { useEffect, useMemo, useRef, useState } from "react";

export const useSingleActiveTab = () => {
  const myTabId = useMemo(() => crypto.randomUUID(), []);
  const [isActiveTab, setIsActiveTab] = useState(true);
  const channelRef = useRef(null);

  useEffect(() => {
    const channel = new BroadcastChannel("chat-tab-channel");
    channelRef.current = channel;

    const handleMessage = (event) => {
      const { type, id } = event.data;

      if (type === "TAB_CLAIMED" && id !== myTabId) {
        setIsActiveTab(false); // Another tab became active
      }
    };

    channel.onmessage = handleMessage;

    // Claim active on first load
    channel.postMessage({ type: "TAB_CLAIMED", id: myTabId });

    return () => {
      channel.close();
    };
  }, [myTabId]);

  // Manual activation method
  const manuallyActivate = () => {
    channelRef.current?.postMessage({ type: "TAB_CLAIMED", id: myTabId });
    setIsActiveTab(true);
  };

  return { isActiveTab, manuallyActivate };
};

export default useSingleActiveTab;
